/**
 * Date formatting utilities with Indian Standard Time (IST/UTC+5:30)
 */

/**
 * Format date/time to IST locale string
 * @param {string|Date|number} dateInput - Date to format
 * @returns {string} Formatted date-time string in IST
 */
export const formatDateTime = (dateInput) => {
  if (!dateInput) return '—';
  try {
    const date = new Date(dateInput);
    return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  } catch {
    return dateInput;
  }
};

/**
 * Format date only (no time) to IST locale string
 * @param {string|Date|number} dateInput - Date to format
 * @returns {string} Formatted date string in IST
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return '—';
  try {
    const date = new Date(dateInput);
    return date.toLocaleDateString('en-IN', { 
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateInput;
  }
};

/**
 * Format time only (no date) in IST
 * @param {string|Date|number} dateInput - Date to format
 * @returns {string} Formatted time string
 */
export const formatTime = (dateInput) => {
  if (!dateInput) return '—';
  try {
    const date = new Date(dateInput);
    return date.toLocaleTimeString('en-IN', { 
      timeZone: 'Asia/Kolkata',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch {
    return dateInput;
  }
};

/**
 * Format with custom options
 * @param {string|Date|number} dateInput - Date to format
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string
 */
export const formatDateCustom = (dateInput, options = {}) => {
  if (!dateInput) return '—';
  try {
    const date = new Date(dateInput);
    return date.toLocaleString('en-IN', { 
      timeZone: 'Asia/Kolkata',
      ...options 
    });
  } catch {
    return dateInput;
  }
};
